import { render } from "./AposWidgetEditor.vue?vue&type=template&id=f57e21dc&scoped=true"
import script from "./AposWidgetEditor.vue?vue&type=script&lang=js"
export * from "./AposWidgetEditor.vue?vue&type=script&lang=js"

import "./AposWidgetEditor.vue?vue&type=style&index=0&id=f57e21dc&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f57e21dc"],['__file',"widget-type/ui/apos/components/AposWidgetEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f57e21dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f57e21dc', __exports__)) {
    api.reload('f57e21dc', __exports__)
  }
  
  module.hot.accept("./AposWidgetEditor.vue?vue&type=template&id=f57e21dc&scoped=true", () => {
    api.rerender('f57e21dc', render)
  })

}


export default __exports__